import type { TypographyProps } from '../types/typography.types';
import { cn } from '@utils';
import React from 'react';

const Body2AccentTypography = React.forwardRef<HTMLHeadingElement, TypographyProps>(
	({ className, children, truncate = true, ...props }, ref) => (
		<h4 ref={ref} className={cn(`scroll-m-20 text-sm font-medium ${truncate ? 'truncate' : ''}`, className)} {...props}>
			{children}
		</h4>
	)
);

Body2AccentTypography.displayName = 'Body2AccentTypography';

export default Body2AccentTypography;
